import {DataGridSearchByColumns} from "../common/globals";

export class DataGridSettingModel {
  dataGridName?: string;
  columns: DataGridColumnModel[] = [];
  sorting?: boolean;
  sortBy?: string;
  isDataPaged!: boolean;
  dataService: any;
  createServiceName?: string;
  defaultPageSize!: '1' | '5' | '15' | '10' | '20' | '30' | '50' | '100';
  enableSearch?: boolean;
  enableRefresh?: boolean;
  enableQuickEdit?: boolean;
  viewUrl?: string;
  editUrl?: string;
  changePasswordUrl?: string;
  addUrl?: string;
  deleteUrl?: string;
  dataGridID?: string;
  searchTitle?: string;
  searchColumnName?: string;
  addButtonName?: string

  getAllServiceName?: string;
  getAllServicePrependArgument?: any;
  getAllServiceAppendArgument?: any;

  searchColumns?: Array<DataGridSearchByColumns>;
  totalCount?: number;

  //new
  hasIdParam?: boolean = false;
  selectionList?: SelectionListModel[] = []
  selectionName?: string

  secondSelectionList?: SelectionListModel[] = []
  secondSelectionName?: string

  enableRadioButtons?: boolean = false
  generateReportServiceName?: string;
  generatedReportFileName?: string;

  addComponent?: string;
  editComponent?: string;
  changePasswordComponent?: string;

  //tabs
  hasTabs?: boolean;
  tabs?: DataGridTabModel[];
  selectedTab?: number;
  hasBooleanParam?: boolean;

  //global search bar
  hasGlobalSearchBar?: boolean
}

export class DataGridColumnModel {
  DbName!: string;
  Name!: string;
  Type!: DataGridColumnType;
  DateTimeFormat?: 'dd.MM.yyyy' | 'dd.MM.yyyy HH:mm' | 'dd MMMM, yyyy' | 'dd MMMM, yyyy HH:mm' | 'dd/MM/yyyy' | 'dd/MM/yy HH:mm' | 'dd.MM.yy' | 'dd.MM.yy HH:mm' | 'dd MMMM, yy' | 'dd MMMM, yy HH:mm' | 'dd/MM/yy' | 'dd/MM/yy HH:mm';
  TextAlign?: 'center' | 'right';
  FontWeight?: 'bold' | 'normal';
  IsDbNameNested?: boolean;

  LocalizationKey?: string;

  Width?: string;

}

export enum DataGridColumnType {
  String = 'string',
  Number = 'number',
  Bool = 'boolean',
  Date = 'date',
  Image = 'image',
  Edit = 'edit',
  ChangePassword = 'changePassword',
  View = 'view',
  Delete = 'delete',
  DateTime = "datetime"
}

export interface DataGridSearchModel {
  SearchParam: string | null;
  FromDate: Date | null;
  ToDate: Date | null;
  SelectionId: number | null;
  SecondSelectionId: number | null;
}

export interface DataGridSearchPagedModel extends DataGridSearchModel {
  Sorting: string;
  SkipCount: number;
  MaxResultCount: number;
}

export interface DataGridStateModel {
  ID: string | undefined;
  PageSize: number;
  CurrentPage: number;
  SortBy: string | undefined;
  SearchActive: boolean;
  SearchParam: string | null;
  SearchFromDate: Date | null;
  SearchToDate: Date | null;
}

export interface PagerModel {
  Sorting: string;
  SkipCount: number;
  MaxResultCount: number;
  SearchParam: string; //
  SelectionId: number;//
  SecondSelectionId: number;//
  FromDate: Date;//
  ToDate: Date;//
}

export interface SearchParametersDto extends PagerModel {
  FromDate: Date;
  ToDate: Date;
  SearchParam: string;
}

export interface SelectionListModel {
  id: number,
  name: string
}

export interface DataGridTabModel{
  name: string,
  value: number
  booleanValue?: boolean
}
